import windowUrl from './windowUrl';

const HOST_REGEX = /^https?:\/\/([^/]+)/;

const getHost = (requestUrl) => {
  const url = requestUrl || windowUrl;

  if (!url) {
    return null;
  }

  const [, host] = url.match(HOST_REGEX);
  return host;
};

export default getHost;
